import { Edit, InfoOutline } from '@mui/icons-material';
import {
  Box,
  IconButton,
  styled,
  Theme,
  Tooltip,
  Typography,
} from '@mui/material';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { Column, Row } from '../Layout';

type StaticFieldSize = 'sm' | 'md' | 'lg';

const sizesMap: Record<StaticFieldSize, string> = {
  sm: '220px',
  md: '400px',
  lg: '500px',
};

const EditButton = styled(IconButton)({ padding: 0 });
const EditIcon = styled(Edit)({
  width: 16,
  height: 16,
});

const Wrapper = styled(Column, {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: StaticFieldSize }>(({ size }) => ({
  width: '100%',
  maxWidth: size ? sizesMap[size] : '100%',
}));

const ChildrenWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  ...theme.typography.h6,
}));

type Props = {
  label?: string | ReactNode;
  tooltip?: string;
  size?: StaticFieldSize;
  spacing?: keyof Theme['spacingSizes'];
  editable?: boolean;
  onEdit?: () => void;
};

const StaticField: FC<PropsWithChildren<Props>> = ({
  children,
  label,
  size,
  tooltip,
  spacing = 'xs',
  editable = false,
  onEdit,
}) => {
  return (
    <Wrapper size={size} spacing={spacing}>
      {!!label &&
        (typeof label === 'string' ? (
          <Column spacing="xs">
            <Row centered spacing="xxs">
              <Typography color="grey.600" variant="h6">
                {label}
              </Typography>
              {tooltip ? (
                <Tooltip title={tooltip}>
                  <InfoOutline fontSize="inherit" />
                </Tooltip>
              ) : null}
              {editable ? (
                <EditButton size="small" onClick={onEdit}>
                  <EditIcon />
                </EditButton>
              ) : null}
            </Row>
          </Column>
        ) : (
          label
        ))}

      <ChildrenWrapper>{children}</ChildrenWrapper>
    </Wrapper>
  );
};

export default StaticField;
